<template>
    <div id='shake'>
      <div class="shakebox">
        <div class="prize">
            <div class="radiation"><img :src="imgPath+'luckdraw/light.png'"></div>
            <div class="main" :style="'background-image:url('+imgPath+'luckdraw/bg5.png)'">
              <div class="shacks"><img :src="imgPath+'luckdraw/title-top.png'"></div>
              <template v-if="activeState != 1">
                <p class="center" @click="prize()" v-if="shake_type == 'fixed'">
                  <span v-if="remain !=0">您还有{{remain}}次机会</span>
                  <span v-else>您的摇奖次数已达上限</span>
                </p>
                <p class="center" @click="prize()" v-else>
                  <span v-if="allow">
                  摇一摇开始抽奖
                  </span>
                  <span v-else>
                  下一次抽奖：<span class="red">{{hours2}}:{{minites2}}:{{seconds2}}</span>
                  </span>
                </p>
              </template>
            </div>
            <div class="prizes" @click="showPrizs()">
              <img :src="imgPath+'luckdraw/prizes.png'">
              <p>我的奖品</p>
            </div>
        </div>
        <div class="timebox">
            <div class="time" v-if="activeState == -1">
              活动开始倒计时：<span class="day">{{days}}</span>天<span class="hours">{{hours}}</span>时<span class="minute">{{minites}}</span>分<span class="second">{{seconds}}</span>秒
            </div>
            <div class="time" v-if="activeState == 0">
              活动结束倒计时：<span class="day">{{days}}</span>天<span class="hours">{{hours}}</span>时<span class="minute">{{minites}}</span>分<span class="second">{{seconds}}</span>秒
            </div>
            <div class="time" v-if="activeState == 1">
              ~~~~~~~活动已结束~~~~~~~
            </div>
        </div>
        <div class="introduce" :style="'background-image:url('+imgPath+'luckdraw/bg4.png)'">
          <div class="rules rules_box">
            <div class="title" :style="'background-image:url('+imgPath+'luckdraw/title-bg.png)'">活动规则</div>
            <p v-dompurify-html="remark">
              {{remark}}
            </p>
          </div>
          <div class="copyright">- 由美时美客提供技术支持 -</div>
        </div>
      </div>

      <van-popup v-model="show">
        <prizes :prizelist="prizelist" :prizeRemark="prize_remark"></prizes>
        <div class="close"><img @click="closeList" :src="imgPath+'close.png'"></div>
      </van-popup>
      <van-popup v-model="show2">
        <div class="poup center">
          <div class="title"><span @click="cutdown"></span>中奖信息</div>
          <img v-if="prizeImg" :src="prizeImg" class="prizeImg">
          <img v-else :src="imgPath+'nothing.jpg'" class="prizeImg">
          <p v-if="prizeImg">恭喜您，中奖了！！！</p>
          <p v-else>此处空空如也，请再接再厉……</p>
        </div>
      </van-popup>
    </div>
</template>

<script>
import Vue from 'vue';
import tool from '../../kits/Tools.js';
import prizes from './prizes.vue';
import { Toast } from 'vant';
import { Popup } from 'vant';
Vue.use(Popup);
    //保存数据

    export default {
        components:{
          prizes
        },
        data() {
            return {
              fans_id:'',
              aid:'1',
              dsId:'',
              days:'00',
              hours:'00',
              minites:'00',
              seconds:'00',
              end:false,
              show:false,
              show2:false,
              prizeImg:'',
              openType:false,
              start_time:'',
              end_time:'',
              shakeType:false,
              remark:'',
              prize_remark:'',
              activeState:-1,
              prizelist:[],
              chances:1,
              page:1,
              page_num:1,
              shake_type:'fixed',
              remain:0,
              hours2:'00',
              minites2:'00',
              seconds2:'00',
              allow:false,
              isWeixin:true,
              loaded:false,
              imgPath:''
            }
        },
        props:['dispark','initData','currentMid','mid'],
        watch:{
          currentMid(){
            if(!this.loaded && this.currentMid == this.mid){
              Toast.loading({
                mask: true,
                message: '加载中...'
              });
              this.shake();
              this.getData();
            }
          },
          dispark() {
            this.openType = this.open;
          }
        },
        mounted() {
          this.imgPath = tool.imgPath();
        	var current_app_Id = window.localStorage.getItem("current_app_Id");
        	var fans = JSON.parse(window.localStorage.getItem(current_app_Id));
        	this.fans_id = fans.fans_id;
          this.isWeixin = tool.isWeixin();
          this.dsId = tool.getQueryDsId();
        },
        methods: {
            getData(){
              var that = this;
              var option = 'fans_id='+this.fans_id+'&ds_id='+this.dsId;
              this.axios.post(tool.baseUrl()+'/activity/shake/index',option).then(function(data){
                Toast.clear();
                if(data.data.code == "200") {
                  that.start_time = data.data.data.start_time;
                  that.end_time = data.data.data.end_time;
                  that.remark = data.data.data.remark;
                  that.remark = that.remark.replace(/\n/g,'<br/>')
                  that.aid = data.data.data.aid;
                  that.prize_remark = data.data.data.prize_remark;
                  that.shake_type = data.data.data.shake_type;
                  that.remain = data.data.data.remain;
                  that.timeSwitch();
                  that.loaded = true;
                  //console.log('正确111');
                } else {
                  //console.log('错误222');
                }
              }).catch(function(){
                //console.log('错误333');
              })
            },
            prize(){
              //console.log('shake_type='+this.shake_type+'--openType='+this.openType+'---activeState='+this.activeState+'&remain='+this.remain+'---allow='+this.allow);
                if(!this.isWeixin){
                  Toast("请微信登陆后重试");
                  return;
                }
                if(this.openType == false || this.activeState != 0){
                  return false;
                }
                if(this.shake_type != 'fixed'){
                  if(!this.allow){
                    return false;
                  }
                }else{
                  if(this.remain <= 0){
                    Toast('您的摇奖次数已达上限');
                    return false;
                  }
                }
              this.shakeType = true;
              var that = this;
              var option = 'aid='+this.aid+'&fans_id='+this.fans_id+'&ds_id='+this.dsId;
              //console.log(option);
              this.axios.post(tool.baseUrl()+'/activity/shake/win',option).then(function(data){
                that.getData();
                setTimeout(function(){
                  that.shakeType = false;
                },2000)
                that.show2 = true;
                if(data.data.code == "200") {
                  that.prizeImg = data.data.data.prize.pic_url;
                }
              }).catch(function(){
                setTimeout(function(){
                  that.shakeType = false;
                },2000)
                Toast('请求错误');
              })
            },
            shake (){
              var that = this;
              var SHAKE_THRESHOLD = 1800;
              var last_update = 0;
              var x =0 , y =0 , z =0 , last_x = 0 ,last_y = 0 ,last_z = 0;
               // 苹果端微信现在只支持https链接的事件触发HTTP不支持出发事件
              if (window.DeviceMotionEvent) {
                //console.log('设备支持摇一摇');
                window.addEventListener('devicemotion', deviceMotionHandler, false);
              } else {
                //console.log('QAQ本设备不支持摇一摇事件');
              }

              function deviceMotionHandler(eventData) {
                  var acceleration = eventData.accelerationIncludingGravity;
                  var curTime = new Date().getTime();
                  if ((curTime - last_update) > 100) {
                      var diffTime = curTime - last_update;
                      last_update = curTime;
                      x = acceleration.x;
                      y = acceleration.y;
                      z = acceleration.z;
                      var speed = Math.abs(x + y + z - last_x - last_y - last_z) / diffTime * 10000;

                      if (speed > SHAKE_THRESHOLD) {
                        if(!that.shakeType){
                          that.prize();
                        }
                      }
                      last_x = x;
                      last_y = y;
                      last_z = z;
                  }
              }
            },
            timeSwitch(){
                var now = new Date().getTime();
                var start = new Date(this.start_time.replace(/-/g,"/")).getTime();
                var end = new Date(this.end_time.replace(/-/g,"/")).getTime();
                //console.log(now+'--'+start+'--'+end)
                if(now < start){
                  this.activeState = -1;
                  this.countDown(parseInt((start - now)/1000));
                  //console.log('未开始');
                }else if(now > end){
                  this.activeState = 1;
                  //console.log('已结束');
                }else{
                  this.activeState = 0;
                  this.countDown(parseInt((end - now)/1000));
                  if(this.shake_type == 'freq'){
                    if(this.remain == 0){
                      this.allow = true;
                    }else{
                      this.countDown2(this.remain);
                    }
                  }
                  //console.log('正在进行');
                }
            },
            countDown(times){
              clearInterval(timer);
              var that = this;
              var timer = setInterval(function(){
                if(times != 0){
                  times-- ;
                  that.days = that.two(Math.floor(times/24/3600));
                  that.hours = that.two(Math.floor(times%(24*3600)/3600));
                  that.minites = that.two(Math.floor(times%3600/60));
                  that.seconds = that.two(Math.floor(times%60));
                }else{
                  clearInterval(timer);
                  that.timeSwitch();
                }
              },1000)
            },
            two(num){
              if(num < 10){
                return '0'+num;
              }
              return num;
            },
            countDown2(time){
              clearInterval(timer);
              var that = this;
              var times = time;
              var timer = setInterval(function(){
                if(times != 0){
                  times-- ;
                  that.hours2 = that.two(Math.floor(times%(24*3600)/3600));
                  that.minites2 = that.two(Math.floor(times%3600/60));
                  that.seconds2 = that.two(Math.floor(times%60));
                }else{
                  clearInterval(timer);
                  that.allow = true;
                }
              },1000)
            },
            showPrizs (){
              var that = this;
              this.show = true;
              var option = 'aid='+this.aid+'&fans_id='+this.fans_id+'&type=1'+'&page='+this.page;
              this.axios.post(tool.baseUrl()+'/activity/shake/lists',option).then(function(data){
                if(data.data.code == "200") {
                  if(data.data.data){
                    that.prizelist = data.data.data.list;
                  }
                }
              }).catch(function(data){
                console.log('错误'+data);
              })
            },
            cutdown(){
              this.show2 = false;
              this.prizeImg = '';
            },
            closeList(){
              this.show = false;
            }
        }
    }
</script>

<style scoped>
#shake {
  height: 100%;
  background: #f93d3e;
}

.shakebox {
  height: 100%;
  overflow: scroll;
}

.center {
  text-align: center;
}

img {
  width: 100%;
}

.prize {
  height: 100%;
  width: 100%;
  overflow: hidden;
  position: relative;
}

.prizes {
  position: absolute;
  height: 65px;
  text-align: center;
  line-height: 16px;
  color: #fff;
  width: 65px;
  border-radius: 50%;
  background: rgba(0,0,0,0.3);
  top: 10px;
  right: 20px;
  animation: swing 2s ease-in-out infinite;
  font-size: 12px;
  color: #FFF;
}

.prizes img {
  width: 70%;
  margin-top: 5px;
}

@keyframes swing {
  0% {
    transform: rotate(10deg);
  }

  50% {
    transform: rotate(-10deg);
  }

  100% {
    transform: rotate(10deg);
  }
}

.radiation {
  position: absolute;
  top: 20px;
  left: 50%;
  width: 120%;
  margin-left: -60%;
  animation: circle 8s linear infinite;
}

.radiation img {
  width: 100%;
}

@keyframes circle {
  0% {
    transform: rotate(0deg);
  }

  50% {
    transform: rotate(180deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

.main {
  background-repeat: no-repeat;
  background-position: bottom center;
  -webkit-background-size: 100%;
  background-size: 100%;
  height: 100%;
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
}

.main .shacks {
  width: 80%;
  text-align: center;
  margin: 30px auto 20px;
}

.main h4 {
  font-size: 18px;
  color: #fff;
  font-weight: bold;
  line-height: 40px;
}

.main p {
  background: #fda513;
  width: 200px;
  height: 30px;
  line-height: 30px;
  overflow: hidden;
  border-radius: 15px;
  margin: 0 auto;
  color: #fff;
}

.timebox {
  position: relative;
  height: 0;
  width: 100%;
  z-index: 100;
}

.time {
  width: 80%;
  position: absolute;
  bottom: 13px;
  left: 50%;
  margin-left: -40%;
  background: #fff;
  border-radius: 3px;
  padding: 20px 5px;
  text-align: center;
  line-height: 20px;
  box-sizing: border-box;
}

.time span {
  display: inline-block;
  background: #f93d3e;
  color: #fff;
  padding: 0 3px;
  border-radius: 2px;
  margin: 0 2px;
}

.introduce {
  width: 100%;
  overflow: hidden;
  background-repeat: no-repeat;
  background-position: center bottom;
  -webkit-background-size: 100%;
  background-size: 100%;
  line-height: 26px;
  color: #9c9c9c;
  position: relative;
  padding-bottom: 80px;
}

.introduce .rules_box {
  width: 90%;
  border: 4px dotted #f3f91f;
  border-radius: 3px;
  margin: 24px auto 0;
  box-sizing: border-box;
  padding: 15px;
  background: #eb6861;
}

.introduce .title {
  background-repeat: no-repeat;
  background-position: center;
  -webkit-background-size: 100% auto;
  background-size: 100% auto;
  line-height: 36px;
  text-align: center;
  color: #f3f91f;
  font-size: 16px;
  font-weight: bold;
}

.introduce p {
  color: #fff;
}

.copyright {
  position: absolute;
  width: 100%;
  bottom: 0;
  text-align: center;
  color: #f93d3e;
}

.prizeImg {
  max-width: 80%;
  margin: 10px 0;
}

.poup {
  background: #fff;
  border-radius: 10px;
  margin: -10px;
  overflow: hidden;
}

.poup .title {
  height: 52px;
  line-height: 52px;
  background: #ff601a;
  color: #fff;
  position: relative;
  font-size: 17px;
  position: relative;
}

.poup .title span {
  height: 20px;
  width: 20px;
  position: absolute;
  transform: rotate(45deg);
  top: 16px;
  right: 20px;
}

.poup .title span:after {
  content: '';
  height: 2px;
  width: 20px;
  background: #fff;
  position: absolute;
  left: 0;
  top: 9px;
}

.poup .title span:before {
  content: '';
  height: 20px;
  width: 2px;
  background: #fff;
  position: absolute;
  top: 0;
  left: 9px;
}

.poup p {
  margin-bottom: 36px;
  font-size: 17px;
}
</style>